// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {
  SHOW_SPINNER,
  SHOW_COMPONENT_SPINNER
} from '../actions/spinner'

const initialState = {
  show: false,
  showComponentSpinner: false,
  componentSpinnerText: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_SPINNER:
      return {...state, show: action.payload}
    case SHOW_COMPONENT_SPINNER:
      return {
        ...state,
        showComponentSpinner: action.payload.showComponentSpinner,
        componentSpinnerText: action.payload.componentSpinnerText
      }
    case '@@router/LOCATION_CHANGE':
      return {...state, showComponentSpinner: false}
    default:
      return state
  }
}
